import { RotatingPrompt } from './rotating-prompt';

interface SearchPillProps {
  prompts: readonly string[];
  onClick: () => void;
}

export function SearchPill({ prompts, onClick }: SearchPillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group/pill inline-flex h-9 w-full max-w-md cursor-pointer items-center gap-2 rounded-md border border-border bg-card/80 py-0 pl-1.5 pr-3 text-[13px] text-muted-foreground backdrop-blur transition-colors hover:border-foreground/30 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <span className="flex h-6 w-6 shrink-0 items-center justify-center" aria-hidden>
        <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" className="h-4 w-4">
          <g className="fill-foreground/45 transition-colors duration-200 group-hover/pill:fill-foreground/65">
            <rect x="6" y="26" width="8" height="12" rx="4" />
            <rect x="17" y="14" width="8" height="36" rx="4" />
            <rect x="28" y="22" width="8" height="20" rx="4" />
            <rect x="50" y="24" width="8" height="16" rx="4" />
          </g>
          <rect x="39" y="8" width="8" height="48" rx="4" className="fill-primary" />
        </svg>
      </span>
      <span className="h-4 w-px shrink-0 bg-border" aria-hidden />
      <RotatingPrompt prompts={prompts} />
      <kbd className="hidden items-center gap-0.5 rounded border border-border bg-secondary/60 px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground sm:inline-flex">
        <span className="text-[10px]">⌘</span>K
      </kbd>
    </button>
  );
}
